/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type AccountManagerLink_viewer$ref = any;
type SiteNav_viewer$ref = any;
type VipAccountManagerLink_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type BottomBar_viewer$ref: FragmentReference;
export type BottomBar_viewer = {|
  +$fragmentRefs: VipAccountManagerLink_viewer$ref & AccountManagerLink_viewer$ref & SiteNav_viewer$ref,
  +$refType: BottomBar_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "BottomBar_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "VipAccountManagerLink_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "AccountManagerLink_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SiteNav_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '35e74529d9b791fcf429b63ee41bcc64';
module.exports = node;
